"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import NextImage from "next/image";
import { useLightbox } from "./LightboxProvider";
type LightboxImageProps = React.ComponentProps<typeof NextImage> & {
  /**
   * Position of this image within its `LightboxProvider` group
   */
  lightboxIndex: number;
};

/**
 * The image as `ui/Image` would have rendered it, made clickable.
 *
 * Kept separate so `ui/Image` itself needs no hooks and stays renderable from
 * server components.
 */
export const LightboxImage: React.FC<LightboxImageProps> = t0 => {
  const $ = _c(14);
  let lightboxIndex;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      lightboxIndex,
      className: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = lightboxIndex;
    $[2] = props;
    $[3] = t1;
  } else {
    lightboxIndex = $[1];
    props = $[2];
    t1 = $[3];
  }
  const className = t1 === undefined ? "" : t1;
  const {
    openAt
  } = useLightbox();
  let t2;
  if ($[4] !== lightboxIndex || $[5] !== openAt) {
    t2 = () => openAt(lightboxIndex);
    $[4] = lightboxIndex;
    $[5] = openAt;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const open = t2;
  const t3 = `${className} cursor-zoom-in`;
  let t4;
  if ($[7] !== open) {
    t4 = event => {
      if (event.key !== "Enter" && event.key !== " ") {
        return;
      }
      event.preventDefault();
      open();
    };
    $[7] = open;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== open || $[10] !== props || $[11] !== t3 || $[12] !== t4) {
    t5 = <NextImage {...props} className={t3} role="button" tabIndex={0} onClick={open} onKeyDown={t4} />;
    $[9] = open;
    $[10] = props;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};